<template>
<Confirm @confirmed="deleteSample()">
  <template v-slot:activator="{on}">
    <v-btn v-on="on" :loading="loading" :disabled="loading || sample.qa_approved || sample.released" color="error" small tile>DELETE</v-btn>
  </template>
</Confirm>
</template>

<script>
export default {
    name: "DeleteSample",
    components: {},
    data: () => ({
      loading: false,
    }),
    props: {
      sample: {
        required: true,
      }
    },
    methods: {
      async deleteSample(){
        try{
          this.loading = true;
          const sampleId = this.sample.id
          this.$store.dispatch("showLoading", "Deleting sample...", "overlay")
          await this.$store.$db().model('samples').api().destroy(this.sample.uuid, sampleId);
          this.sample = null
          this.$store.dispatch('resetLoading');
          this.$store.dispatch("showSuccess", `Deleted sample ${sampleId}`)
          this.loading = false;
        }catch(err){
          this.$store.dispatch('resetLoading');
          this.$store.dispatch("showError", `Failed to delete sample`)
          this.loading = false;
        }
      },
    }
}
</script>

<style scoped>

</style>
